export default __webpack_public_path__ + "static/media/ellipsis.f27ece59.svg";